<template>
<div v-if="realLock" class="lock-container">
  <h4>La dashboard è già aperta altrove, assicurarsi che nessun altro la stia utilizzando prima di procedere.</h4>
  <v-btn flat primary @click="close"> Riprova </v-btn>
</div>
</template>

<script>
/**
 * Blocca la dashboard in caso sia già aperta altrove
 * @module components/common/Lock
 */
export default {
  name: 'lock',
  data () {
    return {
      realLock: false
    }
  },
  props: ['lock'],
  watch: {
    lock (newLock, oldLock) {
      if(newLock && !oldLock){
        setTimeout(() => {
          this.realLock = newLock
        }, 500)
      }else{
        this.realLock = newLock
      }
    }
  },
  methods: {
    close () {
      window.location.reload()
    }
  }
}
</script>

<style lang="stylus">
.lock-container
  button
    transform scale(2)
    margin-top 20px
  h4
    max-width 800px
    text-align center
</style>


// WEBPACK FOOTER //
// src/components/common/Lock.vue